import Footer from "../../components/containers/Footer";
import { WhiteSpace } from "../../components/supports";
import { PlayerTime } from "../PlayerTime";
import { BR5A_Track } from "../BR5A_Track";
import { useState, useEffect } from "react";
import { Image } from "../../components/supports";
import "./leaderboards.css";


const IgnitionLeaderboards = () =>{
    const [times, setTimes] = useState([]);
    let tracks = [BR5A_Track(110,"TOP RACE.NET SERIES DRIVERS")]
    
    const getTimes = async () =>{
        try {
            const response = await fetch("http://localhost:5000/api/leaderboards/ignition");
            const data = await response.json();
            setTimes(data);
        } catch (error) {
                console.error("Failed to fetch:", error.message);
            return null;
        }
    }

    useEffect (() =>{
        getTimes();
    }, [times])

    return(
        <div id="main_wrapper">
        <header>
            <h1></h1>
            <nav>
            </nav>
        </header>

        <div id="main_container">
     
        <WhiteSpace height="50"/>

                gfddgf
              
        </div>
        <div id="contents">
            <section>
                <article className="article-center">
                   <Image src="/images/nsignitionlogo.png" height={100}></Image>
                </article>
                <section className="leaderboards">
                    {tracks.map((track, trackId) => (
                        
                        <div className="leaderboard-object" key={trackId}>
                        
                        <WhiteSpace height="50"/>
                            <div >
                                <div className="track-header">{track.name}</div>
                                 <div>
                                 <div className="grid-container-b">
                                                    <div className="grid-position grid-element info">
                                                    🏆
                                                    </div>
                                                    <div className="grid-element info">
                                                        Driver
                                                    </div>
                                                    <div className="grid-element info">
                                                        Value
                                                    </div>
                                                    <div className="grid-element info">
                                                        Season
                                                    </div>
                                                </div>
                                    {/* Filter and sort times by timer_value */}
                                    {times
                                        .sort((a, b) => a.timer_value - b.timer_value) // Sort by timer_value
                                        .map((trackTime, trackTimeId) => (
                                         
                                                <div className="grid-container-b">
                                                    <div className="grid-position grid-element">
                                                        {trackTimeId+1}
                                                    </div>
                                                    <div className="grid-element">
                                                        {trackTime.user_name}
                                                    </div>
                                                    <div className="grid-element">
                                                        {trackTime.value_amount}
                                                    </div>
                                                    <div className="grid-element">
                                                        {trackTime.season_day}
                                                    </div>
                                                </div>
                                          
                                        ))}
                                </div>
                            </div>

                        </div>
                    ))}
                </section>
            </section>
        </div>
        <Footer/>
    </div>
    );
};

export default IgnitionLeaderboards;